import { render, staticRenderFns } from "./reporteIngresosDoctor.vue?vue&type=template&id=3d668440&scoped=true"
import script from "./reporteIngresosDoctor.vue?vue&type=script&lang=js"
export * from "./reporteIngresosDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d668440",
  null
  
)

export default component.exports